import Padder from 'src/components/_layout/Padder/Padder'
import ImageReveal from 'src/components/atoms/ImageReveal/ImageReveal'
import RichText from 'src/components/atoms/RichText/RichText'
import Text from 'src/components/atoms/Text/Text'
import Revealer from 'src/components/helpers/Revealer/Revealer'
import { CmsImage, CmsLink } from 'src/types'
import * as Styles from './ImageLaunch.style'
import LineLink from 'src/components/atoms/LineLink'
import FlexWrapper from 'src/components/_layout/FlexWrapper/FlexWrapper'
import { useResponsive } from 'ahooks'
import Image from 'src/components/atoms/Image/Image'

type ImageLaunchProps = {
    title: string
    description: string
    link: CmsLink
    images: Array<CmsImage>
}

const ImageLaunch: React.FC<ImageLaunchProps> = ({
    title,
    description,
    link,
    images,
}) => {
    const responsiveInfo = useResponsive()
    return (
        <Styles.Wrapper>
            {!responsiveInfo.md && (
                <Image
                    src={images[images.length > 1 ? 1 : 0].url}
                    alt={images[images.length > 1 ? 1 : 0].alt}
                    css={{
                        width: '100%',
                        aspectRatio: '3/2',
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                />
            )}
            <Styles.Content as={Padder} top="xs">
                <Revealer>
                    <Text
                        dangerouslySetInnerHTML={{ __html: title }}
                        textVariant="title"
                    />
                </Revealer>
                <Revealer>
                    <Padder top="md">
                        <RichText htmlString={description} />
                        <FlexWrapper
                            justify="end"
                            css={{ paddingRight: '$colWidth' }}
                        >
                            <LineLink {...link} />
                        </FlexWrapper>
                    </Padder>
                </Revealer>
            </Styles.Content>
            {responsiveInfo.md && (
                <Styles.Images>
                    {images.map((image, i) => (
                        <ImageReveal {...image} key={i} />
                    ))}
                </Styles.Images>
            )}
        </Styles.Wrapper>
    )
}

export default ImageLaunch
